module.exports = __webpack_public_path__ + "bg.png?8cfe157784c678ba51c2abb7294004b8";


//////////////////
// WEBPACK FOOTER
// ./images/bg.png
// module id = 156
// module chunks = 0